module.exports = __webpack_public_path__ + "static/img/3_2_4.f1e80fd4.jpg";